module.exports = __webpack_public_path__ + "img/usuarios_2_mask.8bcdff05.svg";